export default class Modal {
    static show(modalID: string, onClose?: () => void) {
        const dialogElement = this.getDialogElement(modalID);

        const handleCloseClick = (e: Event, dialog: HTMLDialogElement) => {
            e.preventDefault();
            dialog.close();
            onClose?.();
        };

        const handleModalClose = (modalID: string) => {
            this.close(modalID);
        };

        dialogElement.addEventListener('click', (e) => {
            const target = e.target as HTMLElement;
            const closeElement = target.closest('[data-modal-close]');

            if (closeElement) {
                handleCloseClick(e, dialogElement);
            }
        });

        dialogElement.addEventListener('close', () => {
            handleModalClose(modalID);
        });

        dialogElement.showModal();
    }

    static close(modalID: string) {
        const dialogElement = this.getDialogElement(modalID);
        dialogElement.close();
    }

    static getDialogElement(modalID: string): HTMLDialogElement {
        const dialogElement = document.getElementById(
            modalID,
        ) as HTMLDialogElement;

        if (!dialogElement || !(dialogElement instanceof HTMLDialogElement)) {
            throw new Error(`Dialog with id '${modalID}' not found`);
        }

        return dialogElement;
    }
}
